import React, { Component } from 'react';
import { MdClose as CloseIcon } from 'react-icons/lib/md';
import './FilterModal.css';


class FilterModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  render() {
    const {
      closeModal, children, title,
    } = this.props;
    return (
      <div className="filter-modal">
        <div className="filter-content">
          <div className="filter-title">
            {title}
            <CloseIcon size="36"
              onClick={closeModal}
            />
          </div>
          <div className="fitler-body">
            {children}
          </div>
        </div>
      </div>
    );
  }
}

export default FilterModal;
